import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'slash', 'Slash', [["path",{"d":"M17 5l-10 14","key":"svg-0"}]]);